import React from 'react'

import * as Form from 'modules/plan/components/Form'
import * as Layout from '../Layout/Section'

import * as styles from './styles.module.scss'

/**
 */
export const SelectProperty = () => (
  <Layout.Container>
    <Layout.Title>Room</Layout.Title>
    <Layout.Description>お部屋番号をお選び下さい。</Layout.Description>
    <Layout.Content>
      <Form.Fields.Property />
    </Layout.Content>
  </Layout.Container>
)
